import React from 'react';
import { Typography, Stack } from '@mui/material';
import { withTranslation, WithTranslation } from 'react-i18next';

const NotificationsListEmpty = ({ t: translate }: WithTranslation) => (
  <Stack
    sx={{ textAlign: 'center' }}
    data-testid='notification-empty'
    id='notification-empty'
  >
    <Typography className='kfic2-bodyTextBold' id='notification-empty-title'>
      {translate('youAreAllCaughtUp')}
    </Typography>
    <Typography
      className='kfic2-bodyTextSmall'
      id='notification-empty-description'
    >
      {translate('noNewNotifications')}
    </Typography>
  </Stack>
);

export default withTranslation()(NotificationsListEmpty);
